import ElliiThemeProvider from 'Common/components/ElliiThemeProvider'
import WebFont from 'webfontloader'
import { BrowserRouter as Router } from 'react-router-dom'

import { GlobalStyle, Toaster } from '@redriverpress/system'

import { STD_ONBOARDING_PATH } from './common/constants'
import { StudentOnboardingProvider } from './context/onboardingStudentContext'
import OnboardingStudentManager from './OnboardingStudentManager'

export default function App() {
  WebFont.load({
    google: {
      families: ['Open Sans:400italic,300,400,600,600italic,700,700italic'],
    },
  })

  return (
    <Router basename={STD_ONBOARDING_PATH.basename}>
      <StudentOnboardingProvider>
        <ElliiThemeProvider>
          <Toaster>
            <GlobalStyle />
            <OnboardingStudentManager />
          </Toaster>
        </ElliiThemeProvider>
      </StudentOnboardingProvider>
    </Router>
  )
}
